import { useState } from "react";

const FilterSelect = ({
  name,
  value,
  onChange,
  options,
  placeholder = "Select Option",
}) => {
  const [open, setOpen] = useState(false);

  const isMobile = window.innerWidth <= 768;

  // Selected label
  const selectedLabel =
    options.find((opt) => opt.value === value)?.label || placeholder;

  /* ================= DESKTOP (native select) ================= */
  if (!isMobile) {
    return (
      <select
        name={name}
        value={value}
        onChange={onChange}
        className="border border-gray-500 focus:outline-none px-3 py-2 rounded text-sm"
      >
        <option value="">{placeholder}</option>
        {options.map((opt) => (
          <option
            key={opt.value}
            value={opt.value}
            className={opt.className || ""}
          >
            {opt.label}
          </option>
        ))}
      </select>
    );
  }

  /* ================= MOBILE (floating popup) ================= */
  return (
    <>
      {/* Trigger */}
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="w-full border border-gray-500 px-3 py-2 rounded text-sm text-left bg-white"
      >
        {selectedLabel}
      </button>

      {/* Floating popup */}
      {open && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center">
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-black/40"
            onClick={() => setOpen(false)}
          />

          {/* Popup */}
          <div className="relative bg-white w-[85%] max-w-sm rounded-lg shadow-lg p-4">
            <h3 className="text-sm font-semibold mb-3 text-gray-700">
              {placeholder}
            </h3>

            <div className="flex flex-col gap-2 max-h-[60vh] overflow-y-auto">
              {options.map((opt) => (
                <button
  key={opt.value}
  onClick={() => {
    onChange({
      target: {
        name,
        value: value === opt.value ? "" : opt.value, // ✅ TOGGLE
      },
    });
    setOpen(false);
  }}

                  className={`text-left px-3 py-2 rounded text-sm hover:bg-gray-100 ${
                    value === opt.value
                      ? "bg-blue-50 text-blue-700 font-medium"
                      : "text-gray-700"
                  } ${opt.className || ""}`}
                >
                  {opt.label}
                </button>
              ))}
            </div>

            <button
              className="mt-4 w-full text-sm text-gray-500"
              onClick={() => setOpen(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default FilterSelect;
